import React, { Component } from 'react';
import { Table } from 'react-bootstrap';
import { connect } from 'react-redux';
import moment from 'moment';
import _ from 'lodash';
import FontAwesome from 'react-fontawesome';
import { Link } from 'react-router-dom';
import { calendarsLoaded, removeCalendar, bookingTypesLoaded } from '../../actions';
import { bookingActions } from '../../webapi';
import { checkLoggedIn, validateAccess } from '../../session';
import { Text } from '../../components/text';

class BookingCalendars extends Component {
  state = {
    sortColumn: 'EndTime', // column to sort by
    sortDesc: true, // if true, sort descending rather than ascending
  };

  componentDidMount() {
    checkLoggedIn(this, this.props.auth);
    this.getData();
  }

  getData() {
    bookingActions.getCalendarsBySite(this.props.auth.site).then((res) => {
      this.props.calendarsLoaded(res.data.Items);
    });

    bookingActions.getBookingTypesBySite(this.props.auth.site).then((res) => {
      this.props.bookingTypesLoaded(res.data.Items);
    });
  }

  getTypeTitle = (id) => {
    const bookingType = this.props.bookingTypes.find((t) => t.Id === id);
    if (!bookingType) {
      return '';
    }
    return bookingType.Title;
  };

  sortByCol(col) {
    if (this.state.sortColumn === col) {
      this.setState({
        sortDesc: !this.state.sortDesc,
      });
    } else {
      this.setState({
        sortColumn: col,
        sortDesc: false,
      });
    }
  }

  removeCalendar(calendar) {
    if (window.confirm(`Are you sure you want to delete that calendar?`)) {
      this.props.removeCalendar(calendar.Id);
      bookingActions
        .deleteCalendar(calendar.Id)
        .then((res) => {
          this.getData();
        })
        .catch((res) => {
          alert('Something went wrong with the request. Please try again.');
        });
    }
  }

  renderItems(source) {
    return source.map((ev) => {
      return (
        <tr key={ev.Id}>
          <td className="table-TitleColumn">
            <Link to={`/bookings/calendar/${ev.Id}`}>{ev.Title}</Link>
          </td>
          <td>{moment(ev.Changed).format('D MMM YYYY')}</td>
          <td>{ev.BookingTypes.map((id) => this.getTypeTitle(id)).join(', ')}</td>
          <td className="table-options">
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {validateAccess(this.props.auth.site, 'bookings', this.props.auth) && (
                <Link to={`/bookings/calendar/${ev.Id}`}>
                  <FontAwesome
                    style={{
                      fontSize: 20,
                      padding: 5,
                      marginLeft: 12,
                      cursor: 'pointer',
                    }}
                    name="pencil"
                  />
                </Link>
              )}
              {validateAccess(this.props.auth.site, 'bookings', this.props.auth) && (
                <a
                  onClick={() => {
                    this.removeCalendar(ev);
                  }}
                >
                  <FontAwesome style={{ fontSize: 20, padding: 5, marginLeft: 8, cursor: 'pointer' }} name="minus-circle" />
                </a>
              )}
            </div>
          </td>
        </tr>
      );
    });
  }

  renderSort(col) {
    if (col !== this.state.sortColumn) {
      return null;
    }
    return <FontAwesome style={{ marginLeft: 5 }} name={this.state.sortDesc ? 'chevron-up' : 'chevron-down'} />;
  }

  sortIsActive(col) {
    if (col !== this.state.sortColumn) {
      return '';
    }
    return ' table--columnActive';
  }

  renderView(source) {
    return (
      <Table className="plussTable" striped bordered condensed hover>
        <thead>
          <tr>
            <th
              className={`${this.sortIsActive('Title')}`}
              style={{ cursor: 'pointer' }}
              onClick={() => {
                this.sortByCol('Title');
              }}
            >
              Title{this.renderSort('Title')}
            </th>
            <th
              className={`${this.sortIsActive('Changed')}`}
              style={{ cursor: 'pointer', width: 120 }}
              onClick={() => {
                this.sortByCol('Changed');
              }}
            >
              Last Changed{this.renderSort('Changed')}
            </th>
            <th style={{ width: 140 }}>Booking Types</th>
            <th style={{ width: 70 }} />
          </tr>
        </thead>
        <tbody>{this.renderItems(source)}</tbody>
      </Table>
    );
  }

  renderEmpty() {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', flex: 1, justifyContent: 'center', alignItems: 'center', marginTop: 32 }}>
        <div className="emptyState" />
        <div className="marginTop-32" style={{ maxWidth: 500, textAlign: 'center' }}>
          <Text type="h3">There are no calendars</Text>
        </div>
      </div>
    );
  }

  renderContent() {
    let source = _.sortBy(this.props.calendars, this.state.sortColumn);
    if (this.state.sortDesc) {
      source.reverse();
    }
    // source = []
    if (_.isEmpty(source)) {
      return this.renderEmpty();
    }
    return this.renderView(source);
  }

  render() {
    return <div style={{ minWidth: '100%' }}>{this.renderContent()}</div>;
  }
}

const mapStateToProps = (state) => {
  const { calendars, types } = state.bookings;
  const { auth } = state;
  return {
    calendars,
    auth,
    bookingTypes: types,
  };
};

export default connect(mapStateToProps, { calendarsLoaded, removeCalendar, bookingTypesLoaded })(BookingCalendars);
